var { initialize } = require('./handshake-state')

// There is a React Native bug (?) that causes `nacl.randomBytes` fails to initialize if
// `tweetnacl` is required before requiring `crypto`. Here, we must require `handshake-state`
// (which use `crypto`) before `dh` to work around this issue.
var { generateKeypair } = require('./dh')

module.exports = {
  generateKeypair,
  initialize
}
